import React, { Component } from "react";
import moment from "moment";

const index = ({ day, from, to, close }) => {
  from = moment(from, "HH:mm").format("hh:mm A");
  to = moment(to, "HH:mm").format("hh:mm A");

  if (close) {
    return (
      <div className="business-text d-flex flex-row justify-content-between">
        <div className="text-left">
          <h5 className="text-uppercase">{day} closed</h5>
        </div>
      </div>
    );
  }

  return (
    <div className="business-text d-flex flex-row justify-content-between">
      <div className="text-left">
        <h5 className="text-uppercase">{day}</h5>
      </div>
      <div className="text-right">
        <h5>
          {from} - {to}
        </h5>
      </div>
    </div>
  );
};

export default index;



// WEBPACK FOOTER //
// ./components/ServiceBottom/WorkingHoursContainer/WorkingHours/index.js